'use client';
import { useUserAgentContext } from 'providers/UserAgentProvider';

export const useUserAgent = () => {
  const { isWebView, isAndroid, isIos, userAgent } = useUserAgentContext();

  return {
    isWebView,
    isAndroid,
    isIos,
    userAgent
  };
};
